/**
 * 직위 배정의 **의사 여부**(2026-11-04 · 직무 신규교육 「선임 후 3개월(보건관리자가 의사인 경우는 1년)」 — 산업안전보건법 시행규칙 제29조①).
 *
 * ⚠️ 입력 칸을 **보건관리자 직위(`ART_18`)에만** 그린다 — 하드코딩이다. 근거는 법 문언이 「보건관리자가 의사인 경우」로 직위를 특정하는 것이고,
 * 기한을 실제로 바꾸는 판정은 서버 카탈로그의 사람 사실 변형(`PERSON_FACT` · `ART_18:PHYSICIAN`)이 한다. 카탈로그가 다른 직위의 사실을 더하면
 * (예: `ART_17:PHYSICIAN`) 이 상수도 함께 본다.
 */
export const PHYSICIAN_FACT_POSITIONS: readonly string[] = ['ART_18'];

export type PhysicianChoice = 'unknown' | 'yes' | 'no';

export function toPhysicianChoice(value: boolean | null | undefined): PhysicianChoice {
  return value === true ? 'yes' : value === false ? 'no' : 'unknown';
}

export function fromPhysicianChoice(choice: PhysicianChoice): boolean | null {
  return choice === 'yes' ? true : choice === 'no' ? false : null;
}

export const PHYSICIAN_CHOICE_LABEL: Record<PhysicianChoice, string> = {
  unknown: '의사 여부 모름',
  yes: '의사',
  no: '의사 아님',
};
